import { useEffect, useState } from 'react'
import { Table } from 'antd'
import useGlobalModel from '@/model/globalModel'
import { useNavModel } from '@/model/navModel'
import { useModel } from '../model'
import YhTootip from '@/components/YhTootip'
import { momentFormat } from '@/utils/utils'
import { YhTableSort } from '@/components/YhTableSort'
import { commonService } from '@/service/common'
import { SettingOutlined } from '@ant-design/icons'
import { useDictModel } from '@/views/base/dict/dictModel'
import { setStatusTag } from '@/App'
import { DictCodeEnmu } from '@/types/AppDictEnums'

const sortKey = 'inventoryCounting'

export function DataTable() {
    const {
        user: { branch },
    } = useGlobalModel()
    const { dataSource, pgCfg, updateEditFormVal, loadData, columnsSetVisible, setColumnsSetVisible, orders, loading } = useModel()
    const { addNav, findNav, switchNavState } = useNavModel(() => [])
    const { getTreeNodeNameFine } = useDictModel(() => [])

    useEffect(() => {
        loadData()
        getColumns()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onEdit = (record) => {
        let supplierEditKey = '5-3-1'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.id, mode: 'edit' })
            updateEditFormVal(null)
        } else {
            switchNavState(supplierEditKey, { id: record?.id, mode: 'edit' })
            updateEditFormVal(null)
        }
    }

    const getRegularColumns = [
        {
            title: (
                <>
                    <span>
                        <SettingOutlined
                            onClick={() => {
                                setColumnsSetVisible(true)
                            }}
                        />
                    </span>
                    <span>序号</span>
                </>
            ),
            width: 80,
            fixed: 'left',
            align: 'center',
            render: (t, r, i) => i + 1,
        },
    ]
    const defaultColumns = [
        {
            title: '分支编码',
            width: 100,
            dataIndex: 'branch',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '门店名称',
            width: 140,
            dataIndex: 'shopName',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '140px' }} />,
        },
        {
            title: '盘点单号',
            width: 200,
            dataIndex: 'stocktakingCode',
            isSet: true,
            render: (t, r) => (
                <YhTootip
                    onClick={() => {
                        onEdit(r)
                    }}
                    text={r.stocktakingCode}
                    style={{ width: '200px', color: '#4165E3', cursor: 'pointer' }}
                />
            ),
        },
        {
            title: '盘点状态',
            width: 100,
            dataIndex: 'status',
            isSet: true,
            render: (text) => {
                return setStatusTag(getTreeNodeNameFine(text, `${branch}|inventoryCounting|${DictCodeEnmu.STOCK_CHECK_STATUS}`) || '-')
            },
        },
        {
            title: '账面库存数',
            width: 100,
            dataIndex: 'bookTotalNum',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '实物盘点数',
            width: 100,
            dataIndex: 'realTotalNum',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '差异数量',
            width: 100,
            dataIndex: 'differenceTotalNum',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '差异金额',
            width: 100,
            dataIndex: 'differenceTotalAmount',
            isSet: true,
            render: (text) => <YhTootip text={'￥' + (text || 0)} style={{ width: '100px' }} />,
        },
        {
            title: '报废数量',
            width: 100,
            dataIndex: 'scrapTotalNum',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '报废金额',
            width: 100,
            dataIndex: 'scrapTotalAmount',
            isSet: true,
            render: (text) => <YhTootip text={'￥' + (text || 0)} style={{ width: '100px' }} />,
        },
        {
            title: '盘点开始',
            width: 160,
            dataIndex: 'startTime',
            isSet: true,
            render: (text) => (text ? momentFormat(text) : '-'),
        },
        {
            title: '盘点结束',
            width: 160,
            dataIndex: 'endTime',
            isSet: true,
            render: (text) => (text ? momentFormat(text) : '-'),
        },
        {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '创建时间',
            width: 160,
            dataIndex: 'createTime',
            isSet: true,
            render: (text) => momentFormat(text),
        },
    ]

    const [columns, setColumns] = useState<any[]>([])

    const getColumns = () => {
        commonService.userCustomizeConfigOne(sortKey).then((res) => {
            if (!res.retData) {
                setColumns([...getRegularColumns, ...defaultColumns])
            } else {
                let newColumns: any[] = [...getRegularColumns]
                let data = JSON.parse(res.retData.val)
                data.forEach((element) => {
                    if (element.isShow) {
                        newColumns.push({ ...defaultColumns.find((i) => i.dataIndex === element.key), sorter: element.isSort })
                    }
                })
                setColumns(newColumns)
            }
        })
    }

    const onSuccess = () => {
        setColumnsSetVisible(false)
        getColumns()
    }

    const onChange = (pagination, filters, sorter) => {
        if (sorter.field) {
            if (sorter.order) {
                orders.current = [{ column: sorter.field, asc: sorter.order === 'ascend' }]
            } else {
                orders.current = []
            }
            loadData()
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                onChange={onChange}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
            />
            <YhTableSort
                sortKey={sortKey}
                visible={columnsSetVisible}
                setVisible={setColumnsSetVisible}
                defaultColumns={defaultColumns}
                onSuccess={onSuccess}
            />
        </>
    )
}
